var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 68,
    viewBox: "0 0 67 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3984 17.2051C11.5553 17.2051 0.333252 28.4271 0.333252 42.2702C0.333252 56.1133 11.5553 67.3353 25.3984 67.3353C39.2415 67.3353 50.4635 56.1133 50.4635 42.2702C50.4635 28.4271 39.2415 17.2051 25.3984 17.2051ZM37.345 50.4277V54.334H27.1887V50.6788L33.0955 44.772C33.2046 44.6634 33.2912 44.5343 33.3501 44.392C33.409 44.2498 33.4391 44.0973 33.4387 43.9434C33.4387 43.2971 32.9131 42.7715 32.2668 42.7715C31.6206 42.7715 31.095 43.2971 31.095 43.9434H27.1887C27.1887 41.1432 29.4667 38.8652 32.2668 38.8652C35.067 38.8652 37.345 41.1432 37.345 43.9434C37.345 45.2997 36.8167 46.575 35.8576 47.5341L32.9639 50.4279H37.345V50.4277ZM24.259 43.9434C24.259 47.7126 21.1924 50.7793 17.4231 50.7793C13.6538 50.7793 10.5872 47.7126 10.5872 43.9434V36.1309C10.5872 32.3616 13.6538 29.2949 17.4231 29.2949C21.1924 29.2949 24.259 32.3616 24.259 36.1309V43.9434Z",
    fill: "#969C9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4219 33.2012C15.8065 33.2012 14.4922 34.5155 14.4922 36.1309V43.9434C14.4922 45.5587 15.8065 46.873 17.4219 46.873C19.0372 46.873 20.3516 45.5587 20.3516 43.9434V36.1309C20.3516 34.5154 19.0372 33.2012 17.4219 33.2012Z",
    fill: "#969C9A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0938 8.48047C65.2511 8.48047 67 6.73158 67 4.57422C67 2.41686 65.2511 0.667969 63.0938 0.667969C60.9364 0.667969 59.1875 2.41686 59.1875 4.57422C59.1875 6.73158 60.9364 8.48047 63.0938 8.48047Z",
    fill: "#969C9A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.738 24.1837C56.2949 24.1837 59.989 20.4896 59.989 15.9327C59.989 11.3758 56.2949 7.68164 51.738 7.68164C47.1811 7.68164 43.4869 11.3758 43.4869 15.9327C43.4869 20.4896 47.1811 24.1837 51.738 24.1837Z",
    fill: "#969C9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep5);
export default __webpack_public_path__ + "static/media/step_5.bd904f78f8cfe402e98eddb304e7024f.svg";
export { ForwardRef as ReactComponent };